import { z } from 'zod';

export const FlowInputSchemaPropertySchema = z.object({
  id: z.string(),
  description: z.string(),
});

export type FlowInputSchemaProperty = z.infer<typeof FlowInputSchemaPropertySchema>;

export const FlowInputSchemaSchema = z.object({
  properties: z.record(FlowInputSchemaPropertySchema),
});

export type FlowInputSchema = z.infer<typeof FlowInputSchemaSchema>;
